<div
  [class]="parentContainerClasses()"
  (click)="onCheckboxChange($event)"
  (keyup.space)="onCheckboxChange($event)"
  (keyup.enter)="onCheckboxChange($event)"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  (mousedown)="onMouseDown()"
  (mouseup)="onMouseUp()"
  (focus)="onFocus()"
  (blur)="onBlur()"
  tabindex="-1"
>
  <div
    [class]="checkboxContainerClasses()"
    role="checkbox"
    [attr.aria-checked]="isChecked()"
    [attr.tabindex]="isDisabled() ? -1 : 0"
  >
    @if (isChecked() || isDisabled()) {
      <svg-icon [src]="icon()" [svgClass]="checkmarkClasses()"></svg-icon>
    }
  </div>
  <span [class]="labelClasses()">
    <ng-content></ng-content>
  </span>
</div>
